<template>
  <div class="banks-page">
    <div class="banks-page__banks-section banks-page__section-margin">
      <p class="title">은행</p>
      <div class="banks">
        <div
          v-ripple
          :class="{'active' : selectedBankCode && selectedBankCode === bank.bankCode}"
          @click="selectedBankCode=bank.bankCode"
          v-for="(bank, index) in banks"
          :key="index"
        >{{bank.bankName}}</div>
      </div>
    </div>
    <hr class="banks-page__hr" />
    <div class="banks-page__banks-section banks-page__section-margin">
      <p class="title">증권사</p>
      <div class="banks">
        <div
          v-ripple
          :class="{'active' : selectedBankCode && selectedBankCode === bank.bankCode}"
          @click="selectedBankCode=bank.bankCode"
          v-for="(bank, index) in securities"
          :key="index"
        >{{bank.bankName}}</div>
      </div>
    </div>
    <div class="section bottom">
      <button
        class="button next-button"
        @click="select"
        :disabled="!selectedBankCode"
        type="button"
        v-ripple
      >완료</button>
    </div>
  </div>
</template>
<script>
import userApi from '@/api/now/userApi'

export default {
  props: ['accountSelectedBankCode'],
  data() {
    return {
      banks: [],
      securities: [],
      selectedBankCode: null
    }
  },
  async created() {
    try {
      let { data } = await userApi.getBanks()
      let keys = Object.getOwnPropertyNames(data)
      keys.forEach(bankCode => {
        let obj = {}
        obj.bankCode = bankCode
        obj.bankName = data[bankCode].replace(/[은행|증권]/g, '')

        if (this.accountSelectedBankCode && Number(this.accountSelectedBankCode) === Number(bankCode)) {
          this.selectedBankCode = obj.bankCode
        }

        if (bankCode < 100) {
          this.banks.push(obj)
        } else {
          this.securities.push(obj)
        }
      })
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    select() {
      this.$emit('select-bank', this.selectedBankCode)
    }
  }
}
</script>
<style lang="scss" scoped>
$gray-font-color: #727d8c;
$fundablue: #1baaf1;
.banks-page {
  font-size: 15px;
  padding-bottom: calc(9.51% + 50px);
  &__section-margin {
    margin: 0 25px;
  }
  .title {
    margin: 20px 0;
    font-size: 16px;
    font-weight: 900;
    text-align: center;
  }
  &__hr {
    height: 1px;
    width: calc(100% - 50px);
    margin: 30px auto;
    background-color: #d7e1ea;
    border: none;
  }
  &__banks-section {
    .banks {
      display: flex;
      flex-wrap: wrap;
      div {
        flex: 1 0 33%;
        min-width: 86px;
        max-width: 50%;
        text-align: center;
        padding: 13px 0;
        color: $gray-font-color;
        font-weight: 700;

        &:hover {
          cursor: pointer;
        }
      }
      .active {
        background-color: #f4faff;
        color: $fundablue;
      }
    }
  }
}

@media screen and (min-width: 308px) {
  .banks-page__banks-section .banks :last-child {
    max-width: 33%;
  }
}
</style>
